<template>
  <aside class="p-4 self-stretch bg-gray-200" style="width: 300px">
    <!-- <h2 class="mb-4 w-full text-xl font-bold" key="online-header">Languages – {{ channelCountries.length }}</h2>
    <div class="mb-8 grid grid-cols-4 gap-2">
      <div class="flex items-center cursor-pointer" v-for="country in channelCountries" :key="country.name" @click="filter.language = country.name">
        <UiFlag class="flag-lg" :country="country.name" />
        <div class="ml-1 font-bold">{{ country.count }}</div>
      </div>
    </div> -->

    <div class="mb-4">
      <h2 class="w-full text-xl font-bold" key="online-header">Top 100 most used avatars</h2>
    </div>
    <div class="mb-2 flex items-center" v-for="channel in topChannels" :key="channel.id">
      <!-- <div class="mr-2 w-6 text-center" :class="{ 'text-xs': index > 8 }"><span v-show="index + 1 < 10">&nbsp;</span>{{ index + 1 }}.</div> -->
      <div class="flex-1 flex items-center space-x-1">
        <ChannelIcon :channel-id="+channel.id" :size="50" />
        <ChannelInfo :channel-id="+channel.id" />
      </div>
      <div class="ml-2 text-xl font-bold">{{ channel.avatarPercent }}%</div>
    </div>
    <div class="mt-6 pr-12 whitespace-normal text-sm">
      <p class="my-2">
        100% = the sum of the players using these avatars.
      </p>
      <p class="my-2">
        This information is collected from the Diabotical&nbsp;API and is not complete.
      </p>
    </div>
  </aside>
</template>

<script>
  import { computed } from 'vue'
  import { filter, filteredChannels, channelCountries } from '@/store'
  import { sortBy, prettyNumber } from '@/utils'
  import ChannelIcon from '@/components/ChannelIcon'
  import ChannelInfo from '@/components/ChannelInfo'

  export default {
    name: 'Leaderboard',
    components: {
      ChannelIcon,
      ChannelInfo,
    },
    setup() {
      const topChannels = computed(() => {
        const topChannels = sortBy(filteredChannels.value, 'avatarPercent').slice(0, 100)
        const total = topChannels.reduce((sum, channel) => sum + (channel.avatarPercent || 0), 0)
        return topChannels.map(channel => {
          return {
            ...channel,
            avatarPercent: ((100 * channel.avatarPercent) / (total || 1)).toFixed(2),
          }
        })
      })
      return { filter, topChannels, channelCountries, prettyNumber }
    },
  }
</script>

<style></style>
